// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textaera01[data-v-ff61a976] {\n  height: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
